import React, { useState, useEffect } from 'react';
import { Button, Card, Col, Modal, OverlayTrigger, Row, Table, Tooltip } from "react-bootstrap";
import { PencilIcon } from '@primer/octicons-react'
import { BiCalendar, BiPlus, BiTrash, BiXCircle } from "react-icons/bi";
import { ChevronDownIcon, ChevronUpIcon } from '@primer/octicons-react';
import TimeField from 'react-simple-timefield';
import DateTimePicker from 'react-datetime-picker';
import DeleteConfirmDialog  from './DeleteConfirmDialog';
import { axiosAuth_PLATFORM_API } from '../utils/AxoisUtilComponent';
import { useTranslation } from 'react-i18next';
import classes from './AdminPages.module.css';
import { translateAPIError } from '../utils/apiUtils';
import { formatDate } from '../utils/timeUtils';


const CalConfigAdminDetailsView = (props) => {

  const { i18n, t } = useTranslation(['common', 'custom']);

  const [pubHolidaysAttrs,    setPubHolidaysAttrs]    = useState({});
  const [holidays,            setHolidays]            = useState();

  const [targetPubHoliday,    setTargetPubHoliday]    = useState({});

  const [officeHrsAttrs,      setOfficeHrsAttrs]      = useState({});
  const [officeHrsAttrsOrig,  setOfficeHrsAttrsOrig]  = useState({});

  const [bizHrsAttrs,         setBizHrsAttrs]         = useState({});
  const [bizHrsAttrsOrig,     setBizHrsAttrsOrig]     = useState({});

  const [fmHrsAttrs,          setFmHrsAttrs]          = useState({});
  const [fmHrsAttrsOrig,      setFmHrsAttrsOrig]      = useState({});

  const [viewPubHolidaysSect, setViewPubHolidaysSect] = useState(true);
  const [viewOfficeHrsSect,   setViewOfficeHrsSect]   = useState(false);
  const [viewBizHrsSect,      setViewBizHrsSect]      = useState(false);
  const [viewFmHrsSect,       setViewFmHrsSect]       = useState(false);

  const [editOfficeHrsMode,   setEditOfficeHrsMode]   = useState(false);
  const [editBizHrsMode,      setEditBizHrsMode]      = useState(false);
  const [editFmHrsMode,       setEditFmHrsMode]       = useState(false);

  const [pubHolidayDialogMode, setPubHolidayDialogMode] = useState('CLOSE');

  const [editOfficeHrsErr,        setEditOfficeHrsErr]        = useState('');
  const [editBizHrsErr,           setEditBizHrsErr]           = useState('');
  const [editFmHrsErr,            setEditFmHrsErr]            = useState('');

  const [errMsg_fetchPubHolidays, setErrMsg_fetchPubHolidays] = useState('');
  const [errMsg_fetchOfficeHrs,   setErrMsg_fetchOfficeHrs]   = useState('');
  const [errMsg_fetchBizHrs,      setErrMsg_fetchBizHrs]      = useState('');
  const [errMsg_fetchFmHrs,       setErrMsg_fetchFmHrs]       = useState('');
  const [errMsg_pubHolidayDialog, setErrMsg_pubHolidayDialog] = useState('');

  // UI Functions

  // Initialize state
  useEffect(() => {

    fetchPubHolidays();

    fetchOfficeHrs();

    fetchBizHrs();

    fetchFmHrs();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props]);


  const fetchPubHolidays = () => {

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_PLATFORM_API.get("business-configs?name=PUBLIC_HOLIDAYS");

        resolve(res.data);

        if (res.status === 200) {
          setPubHolidaysAttrs(res.data[0]);
          setHolidays(res.data[0].config);
        }
      } catch (error) {
        //setErrMsg_fetchPubHolidays(t(translateAPIError(error)));
        setErrMsg_fetchPubHolidays(t("I18N_ERR_Fail_to_load_pub_holidays"));
      }
    });
  }

  const fetchOfficeHrs = () => {

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_PLATFORM_API.get("business-configs?name=OFFICE_HOURS_OF_WEEK");

        resolve(res.data);

        if (res.status === 200) {
          setOfficeHrsAttrs(res.data[0]);
          setOfficeHrsAttrsOrig(res.data[0]);
        }
      } catch (error) {
        setErrMsg_fetchOfficeHrs(t("I18N_ERR_Fail_to_load_office_hrs"));
      }
    });
  }

  const fetchBizHrs = () => {

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_PLATFORM_API.get("business-configs?name=BUSINESS_HOURS_OF_WEEK");

        resolve(res.data);

        if (res.status === 200) {
          setBizHrsAttrs(res.data[0]);
          setBizHrsAttrsOrig(res.data[0]);
        }
      } catch (error) {
        setErrMsg_fetchBizHrs(t("I18N_ERR_Fail_to_load_biz_hrs"));
      }
    });
  }

  const fetchFmHrs = () => {

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_PLATFORM_API.get("business-configs?name=FM_DAY_SHIFT_HOURS_OF_WEEK");

        resolve(res.data);

        if (res.status === 200) {
          setFmHrsAttrs(res.data[0]);
          setFmHrsAttrsOrig(res.data[0]);
        }
      } catch (error) {
        setErrMsg_fetchFmHrs(t("I18N_ERR_Fail_to_load_fm_hrs"));
      }
    });
  }


  // ----- General UI stuff -----

  function handleToggleViewSect(sect,e) {

    switch (sect) {
      case 'PUBLIC_HOLIDAYS':
        setViewPubHolidaysSect(!viewPubHolidaysSect);
        break;
      case 'OFFICE_HOURS_OF_WEEK':
        setViewOfficeHrsSect(!viewOfficeHrsSect);
        break;
      case 'BUSINESS_HOURS_OF_WEEK':
        setViewBizHrsSect(!viewBizHrsSect);
        break;
      case 'FM_DAY_SHIFT_HOURS_OF_WEEK':
        setViewFmHrsSect(!viewFmHrsSect);
        break;
      default:
        break;
    }
  }


  function onTimeChange(sect,day,side,e, value) {

    let newAttrs = null;

    switch (sect) {
      case 'OFFICE_HOURS_OF_WEEK':
        newAttrs = JSON.parse (JSON.stringify(officeHrsAttrs)); break;
      case 'BUSINESS_HOURS_OF_WEEK':
        newAttrs = JSON.parse (JSON.stringify(bizHrsAttrs));    break;
      case 'FM_DAY_SHIFT_HOURS_OF_WEEK':
        newAttrs = JSON.parse (JSON.stringify(fmHrsAttrs));    break;
      default:
        break;
    }

    if (!newAttrs.config[day][0]) {
      newAttrs.config[day][0]={};
    }

    newAttrs.config[day][0][side] = value;

    switch (sect) {
      case 'OFFICE_HOURS_OF_WEEK':
        setOfficeHrsAttrs(newAttrs); break;
      case 'BUSINESS_HOURS_OF_WEEK':
        setBizHrsAttrs(newAttrs);    break;
      case 'FM_DAY_SHIFT_HOURS_OF_WEEK':
        setFmHrsAttrs(newAttrs);     break;
      default:
        break;
    }
  }


  function onTimeClear(sect,day,e) {
    let newAttrs = null;

    switch (sect) {
      case 'OFFICE_HOURS_OF_WEEK':
        newAttrs = JSON.parse (JSON.stringify(officeHrsAttrs)); break;
      case 'BUSINESS_HOURS_OF_WEEK':
        newAttrs = JSON.parse (JSON.stringify(bizHrsAttrs));    break;
      case 'FM_DAY_SHIFT_HOURS_OF_WEEK':
        newAttrs = JSON.parse (JSON.stringify(fmHrsAttrs));    break;
      default:
        break;
    }

    newAttrs.config[day][0]=null;

    switch (sect) {
      case 'OFFICE_HOURS_OF_WEEK':
        setOfficeHrsAttrs(newAttrs); break;
      case 'BUSINESS_HOURS_OF_WEEK':
        setBizHrsAttrs(newAttrs);    break;
      case 'FM_DAY_SHIFT_HOURS_OF_WEEK':
        setFmHrsAttrs(newAttrs);     break;
      default:
        break;
    }
  }


  function HourSettingRow(props) {
    if (props.editMode) {
      // ### This portion is not used due to a problem: When the user types 1 number, the control loses focus. ###
      // ### Can use again, if able to find a solution. ###
      return (
        <tr>
          <td>{props.title}</td>
          <td> <TimeField value={props.dayVar && props.dayVar.start ? props.dayVar.start : '--:--'}
                          onChange={(e) => props.onTimeChange(props.sect,props.day,'start',e)} style={{width:'50px'}} /> </td>
          <td> <TimeField value={props.dayVar && props.dayVar.end   ? props.dayVar.end   : '--:--'}
                          onChange={(e) => props.onTimeChange(props.sect,props.day,'end',e)}   style={{width:'50px'}} /> </td>
          <td> { props.dayVar    ?
                   <span onClick={(e) => props.onTimeClear(props.sect,props.day,e)}
                         style={{ cursor: 'pointer', color: '#646464' }}> <BiXCircle size={18} /> </span> : null} </td>
        </tr>
      );
    } else {
      return (
        <tr style={{height:'20px'}}>
           <td>{props.title}</td>
           <td>{props.dayVar ? props.dayVar.start : null}</td>
           <td>{props.dayVar ? props.dayVar.end   : null}</td>
        </tr>
      );
    }
  }


  // ----- Public Holiday Stuff -----

  function renderHolidays(holiday, index) {
    return (
      <tr key={index} style={{fontWeight:'300'}}>
        <td>{holiday.date}</td>
        <td>{holiday.name.en}</td>
        <td>{holiday.name.zh_HK}</td>
        <td>{holiday.name.zh_CN}</td>
        <td>
          <OverlayTrigger overlay={<Tooltip id="tooltip-edit-holiday" style={{fontSize:'11px'}}>{t("I18N_TIP_edit_holiday")}</Tooltip>}>
            <span style={{cursor:'pointer', color:'SteelBlue'}} onClick={() => handleEditPubHoliday(index, holiday)}><PencilIcon size={15} /></span>
          </OverlayTrigger>
          <OverlayTrigger overlay={<Tooltip id="tooltip-del-holiday" style={{fontSize:'11px'}}>{t("I18N_TIP_delete_holiday")}</Tooltip>}>
            <span style={{cursor:'pointer', color:'SteelBlue', marginLeft:'8px'}} onClick={() => handleDeletePubHoliday(holiday)}><BiTrash size={16} /></span>
          </OverlayTrigger>
        </td>
      </tr>
    )
  }

  const onInputChange = (e) => {
    setTargetPubHoliday({ ...targetPubHoliday, [e.target.name]: e.target.value })
  }

  const onDatepickerChange = (value) => {
     setTargetPubHoliday({ ...targetPubHoliday, 'date': value })
  }


  // --- Add Public Holiday ---

  function handleAddPubHoliday() {
    setPubHolidayDialogMode('NEW');
  }

  function handlePubHolidayDialogClose() {
    setPubHolidayDialogMode('CLOSE');
    setTargetPubHoliday({});
    setErrMsg_pubHolidayDialog('');
  }

  function handleAddPubHolidaySubmit() {

    // Validation
    if ( !targetPubHoliday.date) {
      setErrMsg_pubHolidayDialog(t("I18N_ERR_Need_date"));
      return;
    } else if (   !targetPubHoliday.name_en    || (targetPubHoliday.name_en.trim().length === 0)
               || !targetPubHoliday.name_zh_HK || (targetPubHoliday.name_zh_HK.trim().length === 0)
               || !targetPubHoliday.name_zh_CN || (targetPubHoliday.name_zh_CN.trim().length === 0)) {
      setErrMsg_pubHolidayDialog(t("I18N_ERR_Need_holiday_name"));
      return;
/*
    } else if ( !targetPubHoliday.description || (targetPubHoliday.description.length === 0)) {
      setErrMsg_pubHolidayDialog(t("I18N_ERR_Need_description"));
      return;
*/
    }

    if (targetPubHoliday.name_en.length > 100) {
      setErrMsg_pubHolidayDialog(t("I18N_ERR_Max_len_name") + 100);
      return;
    } else if (targetPubHoliday.name_zh_HK.length > 100) {
      setErrMsg_pubHolidayDialog(t("I18N_ERR_Max_len_name_no_col") + " (" + t("custom:I18N_Language_2") + "): " + 100);
      return;
    } else if (targetPubHoliday.name_zh_CN.length > 100) {
      setErrMsg_pubHolidayDialog(t("I18N_ERR_Max_len_name_no_col") + " (" + t("custom:I18N_Language_3") + "): " + 100);
      return;
    }

    let tzoffset = (new Date()).getTimezoneOffset() * 60000; //offset in milliseconds
    let tempDate = new Date(targetPubHoliday.date - tzoffset).toISOString().slice(0, 10).replaceAll('-','');
    let tempYear = targetPubHoliday.date.getFullYear().toString();

    for (let i=0; i<pubHolidaysAttrs.config.length; i++) {
      // Check for duplicate name(s)
      if (   (pubHolidaysAttrs.config[i].name.en.toLowerCase()    === targetPubHoliday.name_en.toLowerCase())
          || (pubHolidaysAttrs.config[i].name.zh_HK.toLowerCase() === targetPubHoliday.name_zh_HK.toLowerCase())
          || (pubHolidaysAttrs.config[i].name.zh_CN.toLowerCase() === targetPubHoliday.name_zh_CN.toLowerCase())) {

        // Only same year cannot have duplicate
        if (pubHolidaysAttrs.config[i].year === tempYear) {
          setErrMsg_pubHolidayDialog(t("I18N_ERR_Dup_name_same_yr_in_lang"));
          return;
        }
      }

      // Check for duplicate date
      if (pubHolidaysAttrs.config[i].date === tempDate) {
        setErrMsg_pubHolidayDialog(t("I18N_ERR_Dup_date"));
        return;
      }
    }

    // This is because toISOString() ignores time zone.  Needs to compansate.
    let newHoliday = {
      date: tempDate,
      name: {
        en:    targetPubHoliday.name_en,
        zh_CN: targetPubHoliday.name_zh_CN,
        zh_HK: targetPubHoliday.name_zh_HK
      },
      year: tempYear
    }

    // Insert new holiday into the right place according to sorting order
    let tempPubHolidayAttrs = JSON.parse (JSON.stringify(pubHolidaysAttrs));

    // Find the index to insert
    let i;
    for (i=0; i<tempPubHolidayAttrs.config.length; i++) {
      if (tempPubHolidayAttrs.config[i].date.localeCompare (newHoliday.date) > 0)
        break;
    }

    tempPubHolidayAttrs.config.splice(i, 0, newHoliday);

    const reqBody = tempPubHolidayAttrs;

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_PLATFORM_API.put("business-configs/" + pubHolidaysAttrs.id, reqBody);

        resolve(res.data);

        if (res.status === 200) {
          fetchPubHolidays();
          setErrMsg_pubHolidayDialog('');
          setPubHolidayDialogMode('CLOSE');
          setTargetPubHoliday({});
        }
      } catch (error) {
        setErrMsg_pubHolidayDialog(t(translateAPIError(error)));
      }
    });
  }


  // --- Edit Public Holiday ---

  function handleEditPubHoliday(index, holiday) {
    // Convert date string to Date type
    let year        = holiday.date.substring(0,4);
    let month       = holiday.date.substring(4,6);
    let day         = holiday.date.substring(6,8);

    let tempHoliday = JSON.parse (JSON.stringify(holiday));

    tempHoliday.index = index;
    tempHoliday.date = new Date(year, month-1, day);
    tempHoliday.name_en    = holiday.name.en;
    tempHoliday.name_zh_HK = holiday.name.zh_HK;
    tempHoliday.name_zh_CN = holiday.name.zh_CN;

    setTargetPubHoliday(tempHoliday);

    setPubHolidayDialogMode('EDIT');
  }

  function handleEditPubHolidaySubmit() {

    let tzoffset = (new Date()).getTimezoneOffset() * 60000; //offset in milliseconds;
    let tempDate = new Date(targetPubHoliday.date - tzoffset).toISOString().slice(0, 10).replaceAll('-','');
    let tempYear = targetPubHoliday.date.getFullYear().toString();

    // Validation
    if ( !targetPubHoliday.date) {
      setErrMsg_pubHolidayDialog(t("I18N_ERR_Need_date"));
      return;
    } else if (   !targetPubHoliday.name_en    || (targetPubHoliday.name_en.trim().length    === 0)
               || !targetPubHoliday.name_zh_HK || (targetPubHoliday.name_zh_HK.trim().length === 0)
               || !targetPubHoliday.name_zh_CN || (targetPubHoliday.name_zh_CN.trim().length === 0)) {
      setErrMsg_pubHolidayDialog(t("I18N_ERR_Need_holiday_name"));
      return;
/*
    } else if ( !targetPubHoliday.description || (targetPubHoliday.description.length === 0)) {
      setErrMsg_pubHolidayDialog(t("I18N_ERR_Need_description"));
      return;
*/
    }

    for (let i=0; i<pubHolidaysAttrs.config.length; i++) {
      // If self, no need to check.
      if (targetPubHoliday.index !== i) {
        // Check for duplicate name(s)
        if (   (pubHolidaysAttrs.config[i].name.en    === targetPubHoliday.name_en)
            || (pubHolidaysAttrs.config[i].name.zh_HK === targetPubHoliday.name_zh_HK)
            || (pubHolidaysAttrs.config[i].name.zh_CN === targetPubHoliday.name_zh_CN)) {

          // Only same year cannot have duplicate
          if (pubHolidaysAttrs.config[i].year === tempYear) {
            setErrMsg_pubHolidayDialog(t("I18N_ERR_Dup_name_same_yr_in_lang"));
            return;
          }
        }

        // Check for duplicate date
        if (pubHolidaysAttrs.config[i].date === tempDate) {
          setErrMsg_pubHolidayDialog(t("I18N_ERR_Dup_date"));
          return;
        }
      }
    }

    let tempPubHolidaysAttrs = JSON.parse (JSON.stringify(pubHolidaysAttrs));

    // First remove the old node from the array
    tempPubHolidaysAttrs.config.splice(targetPubHoliday.index, 1);

    // Insert the new node into the right place in the array

    // This is because toISOString() ignores time zone.  Needs to compansate.
    let newHoliday = {
      date: tempDate,
      name: {
        en:    targetPubHoliday.name_en,
        zh_CN: targetPubHoliday.name_zh_CN,
        zh_HK: targetPubHoliday.name_zh_HK
      },
      year: tempYear
    }

    // Find the index to insert
    let i;
    for (i=0; i<tempPubHolidaysAttrs.config.length; i++) {
      if (tempPubHolidaysAttrs.config[i].date.localeCompare (newHoliday.date) > 0)
        break;
    }

    tempPubHolidaysAttrs.config.splice(i, 0, newHoliday);

    const reqBody = tempPubHolidaysAttrs;

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_PLATFORM_API.put("business-configs/" + pubHolidaysAttrs.id, reqBody);

        resolve(res.data);

        if (res.status === 200) {
          fetchPubHolidays();
          setErrMsg_pubHolidayDialog('');
          setPubHolidayDialogMode('CLOSE');
          setTargetPubHoliday(null);
        }
      } catch (error) {
        setErrMsg_pubHolidayDialog(t(translateAPIError(error)));
      }
    });
  }

  // --- Delete Public Holiday ---

  const [errMsgDeleteConfirm, setErrMsgDeleteConfirm] = useState('');
  const [showDeleteDialog,    setShowDeleteDialog]    = useState(false);
  const [deleteTarget,        setDeleteTarget]        = useState(null);

  function handleDeletePubHoliday(holiday) {
    setDeleteTarget(holiday);
    setShowDeleteDialog(true);
  }

  function handleDeleteCancel() {
    setDeleteTarget(null);
    setShowDeleteDialog(false);
  }

  function handleDeleteSubmit() {

    let tempPubHolidayAttrs = JSON.parse (JSON.stringify(pubHolidaysAttrs));

    // Find the index to insert
    let i;
    for (i=0; i<tempPubHolidayAttrs.config.length; i++) {
      if (tempPubHolidayAttrs.config[i].name.en.localeCompare (deleteTarget.name.en) === 0)
        break;
    }

    tempPubHolidayAttrs.config.splice(i, 1);

    const reqBody = tempPubHolidayAttrs;

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_PLATFORM_API.put("business-configs/" + pubHolidaysAttrs.id, reqBody);

        resolve(res.data);

        if (res.status === 200) {
          fetchPubHolidays();
          setShowDeleteDialog(false);
        }
      } catch (error) {
        setErrMsgDeleteConfirm(t(translateAPIError(error)));
      }
    });
  }


  // --- Edit Office Hours ---

  function handleEditOfficeHours() {
    setEditOfficeHrsMode(true);
  }

  function handleEditOfficeHrsCancel() {

    setOfficeHrsAttrs(officeHrsAttrsOrig);
    setEditOfficeHrsMode(false);
    setEditOfficeHrsErr('');
  }

  function handleEditOfficeHrsSubmit() {

    setEditOfficeHrsErr("");

    // Data validation
    if (   validateDayOfWeek(officeHrsAttrs.config.Monday[0],    t("I18N_Monday"),    setEditOfficeHrsErr)
        || validateDayOfWeek(officeHrsAttrs.config.Tuesday[0],   t("I18N_Tuesday"),   setEditOfficeHrsErr)
        || validateDayOfWeek(officeHrsAttrs.config.Wednesday[0], t("I18N_Wednesday"), setEditOfficeHrsErr)
        || validateDayOfWeek(officeHrsAttrs.config.Thursday[0],  t("I18N_Thursday"),  setEditOfficeHrsErr)
        || validateDayOfWeek(officeHrsAttrs.config.Friday[0],    t("I18N_Friday"),    setEditOfficeHrsErr)
        || validateDayOfWeek(officeHrsAttrs.config.Saturday[0],  t("I18N_Saturday"),  setEditOfficeHrsErr)
        || validateDayOfWeek(officeHrsAttrs.config.Sunday[0],    t("I18N_Sunday"),    setEditOfficeHrsErr)) {
      return;
    }

    // Data validation
    if (   (   officeHrsAttrs.config.Monday[0]
            && officeHrsAttrs.config.Monday[0].end.localeCompare   (officeHrsAttrs.config.Monday[0].start)    <= 0)
        || (   officeHrsAttrs.config.Tuesday[0]
            && officeHrsAttrs.config.Tuesday[0].end.localeCompare  (officeHrsAttrs.config.Tuesday[0].start)   <= 0)
        || (   officeHrsAttrs.config.Wednesday[0]
            && officeHrsAttrs.config.Wednesday[0].end.localeCompare(officeHrsAttrs.config.Wednesday[0].start) <= 0)
        || (   officeHrsAttrs.config.Thursday[0]
            && officeHrsAttrs.config.Thursday[0].end.localeCompare (officeHrsAttrs.config.Thursday[0].start)  <= 0)
        || (   officeHrsAttrs.config.Friday[0]
            && officeHrsAttrs.config.Friday[0].end.localeCompare   (officeHrsAttrs.config.Friday[0].start)    <= 0)
        || (   officeHrsAttrs.config.Saturday[0]
            && officeHrsAttrs.config.Saturday[0].end.localeCompare (officeHrsAttrs.config.Saturday[0].start)  <= 0)
        || (   officeHrsAttrs.config.Sunday[0]
            && officeHrsAttrs.config.Sunday[0].end.localeCompare   (officeHrsAttrs.config.Sunday[0].start)    <= 0)) {

      setEditOfficeHrsErr(t("I18N_ERR_End_time_LE_Start_time"));
      return;
    }

    const reqBody = officeHrsAttrs;

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_PLATFORM_API.put("business-configs/" + officeHrsAttrs.id, reqBody);

        resolve(res.data);

        if (res.status === 200) {
          setEditOfficeHrsErr('');
          setEditOfficeHrsMode(false)

          fetchOfficeHrs();
        }
      } catch (error) {
        setEditOfficeHrsErr(t(translateAPIError(error)));
      }
    });
  }

  // --- Edit Business Hours ---

  function handleEditBizHours() {
    setEditBizHrsMode(true);
  }

  function handleEditBizHrsCancel() {

    setBizHrsAttrs(bizHrsAttrsOrig);
    setEditBizHrsMode(false);
    setEditBizHrsErr('');
  }

  function handleEditBizHrsSubmit() {

    setEditBizHrsErr("");

    // Data validation
    if (   validateDayOfWeek(bizHrsAttrs.config.Monday[0],    t("I18N_Monday"),    setEditBizHrsErr)
        || validateDayOfWeek(bizHrsAttrs.config.Tuesday[0],   t("I18N_Tuesday"),   setEditBizHrsErr)
        || validateDayOfWeek(bizHrsAttrs.config.Wednesday[0], t("I18N_Wednesday"), setEditBizHrsErr)
        || validateDayOfWeek(bizHrsAttrs.config.Thursday[0],  t("I18N_Thursday"),  setEditBizHrsErr)
        || validateDayOfWeek(bizHrsAttrs.config.Friday[0],    t("I18N_Friday"),    setEditBizHrsErr)
        || validateDayOfWeek(bizHrsAttrs.config.Saturday[0],  t("I18N_Saturday"),  setEditBizHrsErr)
        || validateDayOfWeek(bizHrsAttrs.config.Sunday[0],    t("I18N_Sunday"),    setEditBizHrsErr)) {
      return;
    }

    if (   (   bizHrsAttrs.config.Monday[0]
            && bizHrsAttrs.config.Monday[0].end.localeCompare   (bizHrsAttrs.config.Monday[0].start)    <= 0)
        || (   bizHrsAttrs.config.Tuesday[0]
            && bizHrsAttrs.config.Tuesday[0].end.localeCompare  (bizHrsAttrs.config.Tuesday[0].start)   <= 0)
        || (   bizHrsAttrs.config.Wednesday[0]
            && bizHrsAttrs.config.Wednesday[0].end.localeCompare(bizHrsAttrs.config.Wednesday[0].start) <= 0)
        || (   bizHrsAttrs.config.Thursday[0]
            && bizHrsAttrs.config.Thursday[0].end.localeCompare (bizHrsAttrs.config.Thursday[0].start)  <= 0)
        || (   bizHrsAttrs.config.Friday[0]
            && bizHrsAttrs.config.Friday[0].end.localeCompare   (bizHrsAttrs.config.Friday[0].start)    <= 0)
        || (   bizHrsAttrs.config.Saturday[0]
            && bizHrsAttrs.config.Saturday[0].end.localeCompare (bizHrsAttrs.config.Saturday[0].start)  <= 0)
        || (   bizHrsAttrs.config.Sunday[0]
            && bizHrsAttrs.config.Sunday[0].end.localeCompare   (bizHrsAttrs.config.Sunday[0].start)    <= 0)) {

      setEditBizHrsErr(t("I18N_ERR_End_time_LE_Start_time"));
      return;
    }

    const reqBody = bizHrsAttrs;

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_PLATFORM_API.put("business-configs/" + bizHrsAttrs.id, reqBody);

        resolve(res.data);

        if (res.status === 200) {
          setEditBizHrsErr('');
          setEditBizHrsMode(false)

          fetchBizHrs();
        }
      } catch (error) {
        setEditBizHrsErr(t(translateAPIError(error)));
      }
    });
  }

  // --- Edit FM Hours ---

  function handleEditFmHours() {
    setEditFmHrsMode(true);
  }

  function handleEditFmHrsCancel() {

    setFmHrsAttrs(fmHrsAttrsOrig);
    setEditFmHrsMode(false);
    setEditFmHrsErr('');
  }

  function handleEditFmHrsSubmit() {

    setEditFmHrsErr("");

    // Data validation
    if (   validateDayOfWeek(fmHrsAttrs.config.Monday[0],    t("I18N_Monday"),    setEditFmHrsErr)
        || validateDayOfWeek(fmHrsAttrs.config.Tuesday[0],   t("I18N_Tuesday"),   setEditFmHrsErr)
        || validateDayOfWeek(fmHrsAttrs.config.Wednesday[0], t("I18N_Wednesday"), setEditFmHrsErr)
        || validateDayOfWeek(fmHrsAttrs.config.Thursday[0],  t("I18N_Thursday"),  setEditFmHrsErr)
        || validateDayOfWeek(fmHrsAttrs.config.Friday[0],    t("I18N_Friday"),    setEditFmHrsErr)
        || validateDayOfWeek(fmHrsAttrs.config.Saturday[0],  t("I18N_Saturday"),  setEditFmHrsErr)
        || validateDayOfWeek(fmHrsAttrs.config.Sunday[0],    t("I18N_Sunday"),    setEditFmHrsErr)) {
      return;
    }

    if (   (   fmHrsAttrs.config.Monday[0]
            && fmHrsAttrs.config.Monday[0].end.localeCompare   (fmHrsAttrs.config.Monday[0].start)    <= 0)
        || (   fmHrsAttrs.config.Tuesday[0]
            && fmHrsAttrs.config.Tuesday[0].end.localeCompare  (fmHrsAttrs.config.Tuesday[0].start)   <= 0)
        || (   fmHrsAttrs.config.Wednesday[0]
            && fmHrsAttrs.config.Wednesday[0].end.localeCompare(fmHrsAttrs.config.Wednesday[0].start) <= 0)
        || (   fmHrsAttrs.config.Thursday[0]
            && fmHrsAttrs.config.Thursday[0].end.localeCompare (fmHrsAttrs.config.Thursday[0].start)  <= 0)
        || (   fmHrsAttrs.config.Friday[0]
            && fmHrsAttrs.config.Friday[0].end.localeCompare   (fmHrsAttrs.config.Friday[0].start)    <= 0)
        || (   fmHrsAttrs.config.Saturday[0]
            && fmHrsAttrs.config.Saturday[0].end.localeCompare (fmHrsAttrs.config.Saturday[0].start)  <= 0)
        || (   fmHrsAttrs.config.Sunday[0]
            && fmHrsAttrs.config.Sunday[0].end.localeCompare   (fmHrsAttrs.config.Sunday[0].start)    <= 0)) {

      setEditFmHrsErr(t("I18N_ERR_End_time_LE_Start_time"));
      return;
    }

    const reqBody = fmHrsAttrs;

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_PLATFORM_API.put("business-configs/" + fmHrsAttrs.id, reqBody);

        resolve(res.data);

        if (res.status === 200) {
          setEditFmHrsErr('');
          setEditFmHrsMode(false)

          fetchFmHrs();
        }
      } catch (error) {
        setEditFmHrsErr(t(translateAPIError(error)));
      }
    });
  }

  function validateDayOfWeek(dayObj, dayName, errFunc) {
    let err = null;

    if (dayObj && dayObj.start) {
      if (dayObj.start.indexOf('-') >= 0) {
        err = dayName + " - " + t("I18N_Start_time") + ": " + t("I18N_ERR_Invalid_time_format");
      } else if (!dayObj.end) {
        err = dayName + ": " + t("I18N_ERR_Miss_st_or_end_time");
      }
    }

    if (dayObj && dayObj.end) {
      if (dayObj.end.indexOf('-') >= 0) {
        err = dayName + " - " + t("I18N_End_time") + ": " + t("I18N_ERR_Invalid_time_format");
      } else if (!dayObj.start) {
        err = dayName + ": " + t("I18N_ERR_Miss_st_or_end_time");
      }
    }

    if (err)
      errFunc(err);

    return(err);
  }


  // ----- BEGIN UI -----

  return (
    <>
      <Card style={{overflow:'auto', border:'0', boxShadow:'0 2px 2px 0px rgba(0,0,0,0.1)',
                    padding:'20px 40px 20px 40px', maxWidth:'2500px', width:'100%', height:'850px',fontSize:'13px'}}>

        <div style={{display:'flex'}}>
          <span className={classes.admin_pages__page_title}>
            {t("I18N_CalConfig_Details")}
          </span>
        </div>

        {/* ----- Public Holidays ----- */}

        <div className={classes.admin_pages__page_subtitle} style={{marginTop:'20px'}}>
          <div style={{display:'flex'}}>
            <span>
              {t("I18N_Pub_Holidays")}
            </span>

            <span style={{marginLeft:'auto'}}>
              <OverlayTrigger overlay={<Tooltip id="tooltip-new_holiday" style={{fontSize:'11px'}}>{t("I18N_TIP_Add_holiday")}</Tooltip>}>
                <span onClick={handleAddPubHoliday} style={{ marginTop: '3px', cursor: 'pointer', color: '#646464' }}>
                  <BiPlus size={18} />
                </span>
              </OverlayTrigger>
            </span>

            <span onClick={(e) => handleToggleViewSect('PUBLIC_HOLIDAYS',e)}
                  style={{ marginLeft:'10px', marginRight:'20px', marginTop:'2px', cursor: 'pointer', color: '#646464' }}>
              { viewPubHolidaysSect ? <ChevronUpIcon size={18} /> : <ChevronDownIcon  size={18} /> }
            </span>
          </div>

          <hr className="solid" style={{ margin: '0 0 0 0' }}></hr>

          { viewPubHolidaysSect && pubHolidaysAttrs && pubHolidaysAttrs.config ?
            <div style={{overflow:'auto', fontSize:'11px', marginLeft:'20px', marginTop:'10px', maxHeight:'450px'}}>

              <Row className={classes.admin_pages__field_value} style={{ marginTop: '0px', width:'100%' }}>
                <Table hover responsive size="sm">
                  <thead style={{color:'#686868', fontSize:'12px', borderBottom:"2px solid #D0D0D0"}}>
                    <tr>
                      <th style={{width:'20%', fontWeight:'400'}}>{t("Date")}</th>
                      <th style={{width:'25%', fontWeight:'400'}}>{t("I18N_Name")}</th>
                      <th style={{width:'20%', fontWeight:'400'}}>{t("I18N_Name") + " (" + t("custom:I18N_Language_2") + ")"}</th>
                      <th style={{width:'20%', fontWeight:'400'}}>{t("I18N_Name") + " (" + t("custom:I18N_Language_3") + ")"}</th>
                      <th style={{width:'5%'}}></th>
                    </tr>
                  </thead>
                  <tbody>
                    {holidays ? holidays.map(renderHolidays) : null}
                  </tbody>
                </Table>
              </Row>

              <Row className={classes.admin_pages__field_label} style={{ marginTop: '0px', width:'100%' }}>
                <Col>{t("I18N_Created_by")}:</Col>
                <Col>{t("I18N_Time_created")}:</Col>
                <Col>{t("I18N_Updated_by")}:</Col>
                <Col>{t("I18N_Time_updated")}:</Col>
              </Row>
              <Row className={classes.admin_pages__field_value} style={{ marginTop: '0px', width:'100%' }}>
                <Col style={{overflowWrap:'anywhere'}}>{pubHolidaysAttrs.creatorUsername}</Col>
                <Col>{formatDate(pubHolidaysAttrs.timeCreated)}</Col>
                <Col style={{overflowWrap:'anywhere'}}>{pubHolidaysAttrs.updaterUsername}</Col>
                <Col>{formatDate(pubHolidaysAttrs.timeUpdated)}</Col>
              </Row>
            </div>
          : null
          }

          <span className={classes.admin_pages__field_label} style={{ color: 'rgba(200,0,0)' }}>
            {errMsg_fetchPubHolidays}
          </span>
        </div>


        {/* ----- Office Hours ----- */}

        <div className={classes.admin_pages__page_subtitle} style={{marginTop:'20px'}}>
          <div style={{display:'flex'}}>
            <span>
              {t("I18N_Office_Hours")}
            </span>
            {editOfficeHrsMode ?
              null
              : viewOfficeHrsSect ?
              <span style={{marginLeft:'15px', marginTop:'5px', fontSize:'9px', color:'SteelBlue', cursor:'pointer'}} onClick={handleEditOfficeHours}>
                <PencilIcon size={12} />
                {t("I18N_Edit")}
              </span>
              : null
            }

            <span onClick={(e) => handleToggleViewSect('OFFICE_HOURS_OF_WEEK',e)}
                  style={{ marginLeft:'auto', marginRight:'20px', marginTop:'2px', cursor: 'pointer', color: '#646464' }}>
              { viewOfficeHrsSect ? <ChevronUpIcon size={18} /> : <ChevronDownIcon  size={18} /> }
            </span>
          </div>

          <hr className="solid" style={{ margin: '0 0 0 0' }}></hr>

          { viewOfficeHrsSect && officeHrsAttrs && officeHrsAttrs.config ?
            <>
              <div style={{overflow:'auto', marginLeft:'20px'}}>
                <Row className={classes.admin_pages__field_value} style={{ marginTop: '0px', width:'100%' }}>
                  <Table hover responsive size="sm" style={{marginTop:'10px', width:'500px'}}>
                    <thead style={{color:'#686868', fontSize:'12px', borderBottom:"2px solid #D0D0D0"}}>
                      <tr>
                        <th>{t("I18N_Day_of_week")}</th>
                        <th>{t("I18N_Start") + " (" + t("I18N_24Hour") + ")"}</th>
                        <th>{t("I18N_End")   + " (" + t("I18N_24Hour") + ")"}</th>
                      </tr>
                    </thead>

                    { editOfficeHrsMode ?

                      <tbody>
{/*
      // ### This portion is not used due to a problem: When the user types 1 number, the control loses focus. ###
      // ### Can use again, if able to find a solution. ###
                        <HourSettingRow editMode={true} title={t("I18N_Monday")}    dayVar={officeHrsAttrs.config.Monday[0]}    sect={'OFFICE_HOURS_OF_WEEK'} day={'Monday'}
                                        onTimeChange={onTimeChange} onTimeClear={onTimeClear} />
                        <HourSettingRow editMode={true} title={t("I18N_Tuesday")}   dayVar={officeHrsAttrs.config.Tuesday[0]}   sect={'OFFICE_HOURS_OF_WEEK'} day={'Tuesday'}
                                        onTimeChange={onTimeChange} onTimeClear={onTimeClear} />
                        <HourSettingRow editMode={true} title={t("I18N_Wednesday")} dayVar={officeHrsAttrs.config.Wednesday[0]} sect={'OFFICE_HOURS_OF_WEEK'} day={'Wednesday'}
                                        onTimeChange={onTimeChange} onTimeClear={onTimeClear} />
                        <HourSettingRow editMode={true} title={t("I18N_Thursday")}  dayVar={officeHrsAttrs.config.Thursday[0]}  sect={'OFFICE_HOURS_OF_WEEK'} day={'Thursday'}
                                        onTimeChange={onTimeChange} onTimeClear={onTimeClear} />
                        <HourSettingRow editMode={true} title={t("I18N_Friday")}    dayVar={officeHrsAttrs.config.Friday[0]}    sect={'OFFICE_HOURS_OF_WEEK'} day={'Friday'}
                                        onTimeChange={onTimeChange} onTimeClear={onTimeClear} />
                        <HourSettingRow editMode={true} title={t("I18N_Saturday")}  dayVar={officeHrsAttrs.config.Saturday[0]}  sect={'OFFICE_HOURS_OF_WEEK'} day={'Saturday'}
                                        onTimeChange={onTimeChange} onTimeClear={onTimeClear} />
                        <HourSettingRow editMode={true} title={t("I18N_Sunday")}    dayVar={officeHrsAttrs.config.Sunday[0]}    sect={'OFFICE_HOURS_OF_WEEK'} day={'Sunday'}
                                        onTimeChange={onTimeChange} onTimeClear={onTimeClear} />
*/}
                        <tr>
                          <td>{t("I18N_Monday")}</td>
                          <td> <TimeField value={officeHrsAttrs.config.Monday[0] && officeHrsAttrs.config.Monday[0].start      ?
                                                 officeHrsAttrs.config.Monday[0].start    : '--:--'}
                                          onChange={(e, value) => onTimeChange('OFFICE_HOURS_OF_WEEK','Monday','start',e,value)}    style={{width:'50px'}} /> </td>
                          <td> <TimeField value={officeHrsAttrs.config.Monday[0] && officeHrsAttrs.config.Monday[0].end        ?
                                                 officeHrsAttrs.config.Monday[0].end      : '--:--'}
                                          onChange={(e, value) => onTimeChange('OFFICE_HOURS_OF_WEEK','Monday','end',e,value)}      style={{width:'50px'}} /> </td>
                          <td> { officeHrsAttrs.config.Monday[0]    ?
                                   <span onClick={(e) => onTimeClear('OFFICE_HOURS_OF_WEEK','Monday',e)}
                                         style={{ cursor: 'pointer', color: '#646464' }}> <BiXCircle size={18} /> </span> : null} </td>
                        </tr>
                        <tr>
                          <td>{t("I18N_Tuesday")}</td>
                          <td> <TimeField value={officeHrsAttrs.config.Tuesday[0] && officeHrsAttrs.config.Tuesday[0].start    ?
                                                 officeHrsAttrs.config.Tuesday[0].start   : '--:--'}
                                          onChange={(e, value) => onTimeChange('OFFICE_HOURS_OF_WEEK','Tuesday','start',e,value)}   style={{width:'50px'}} /> </td>
                          <td> <TimeField value={officeHrsAttrs.config.Tuesday[0] && officeHrsAttrs.config.Tuesday[0].end      ?
                                                 officeHrsAttrs.config.Tuesday[0].end     : '--:--'}
                                          onChange={(e, value) => onTimeChange('OFFICE_HOURS_OF_WEEK','Tuesday','end',e,value)}     style={{width:'50px'}} /> </td>
                          <td> { officeHrsAttrs.config.Tuesday[0]   ?
                                   <span onClick={(e) => onTimeClear('OFFICE_HOURS_OF_WEEK','Tuesday',e)}
                                         style={{ cursor: 'pointer', color: '#646464' }}> <BiXCircle size={18} /> </span> : null} </td>
                        </tr>
                        <tr>
                          <td>{t("I18N_Wednesday")}</td>
                          <td> <TimeField value={officeHrsAttrs.config.Wednesday[0] && officeHrsAttrs.config.Wednesday[0].start ?
                                                 officeHrsAttrs.config.Wednesday[0].start : '--:--'}
                                          onChange={(e, value) => onTimeChange('OFFICE_HOURS_OF_WEEK','Wednesday','start',e,value)} style={{width:'50px'}} /> </td>
                          <td> <TimeField value={officeHrsAttrs.config.Wednesday[0] && officeHrsAttrs.config.Wednesday[0].end   ?
                                                 officeHrsAttrs.config.Wednesday[0].end   : '--:--'}
                                          onChange={(e, value) => onTimeChange('OFFICE_HOURS_OF_WEEK','Wednesday','end',e,value)}   style={{width:'50px'}} /> </td>
                          <td> { officeHrsAttrs.config.Wednesday[0] ?
                                   <span onClick={(e) => onTimeClear('OFFICE_HOURS_OF_WEEK','Wednesday',e)}
                                         style={{ cursor: 'pointer', color: '#646464' }}> <BiXCircle size={18} /> </span> : null} </td>
                        </tr>
                        <tr>
                          <td>{t("I18N_Thursday")}</td>
                          <td> <TimeField value={officeHrsAttrs.config.Thursday[0] && officeHrsAttrs.config.Thursday[0].start   ?
                                                 officeHrsAttrs.config.Thursday[0].start  : '--:--'}
                                          onChange={(e, value) => onTimeChange('OFFICE_HOURS_OF_WEEK','Thursday','start',e,value)}  style={{width:'50px'}} /> </td>
                          <td> <TimeField value={officeHrsAttrs.config.Thursday[0] && officeHrsAttrs.config.Thursday[0].end     ?
                                                 officeHrsAttrs.config.Thursday[0].end    : '--:--'}
                                          onChange={(e, value) => onTimeChange('OFFICE_HOURS_OF_WEEK','Thursday','end',e,value)}    style={{width:'50px'}} /> </td>
                          <td> { officeHrsAttrs.config.Thursday[0]  ?
                                   <span onClick={(e) => onTimeClear('OFFICE_HOURS_OF_WEEK','Thursday',e)}
                                         style={{ cursor: 'pointer', color: '#646464' }}> <BiXCircle size={18} /> </span> : null} </td>
                        </tr>
                        <tr>
                          <td>{t("I18N_Friday")}</td>
                          <td> <TimeField value={officeHrsAttrs.config.Friday[0] && officeHrsAttrs.config.Friday[0].start       ?
                                                 officeHrsAttrs.config.Friday[0].start    : '--:--'}
                                          onChange={(e, value) => onTimeChange('OFFICE_HOURS_OF_WEEK','Friday','start',e,value)}    style={{width:'50px'}} /> </td>
                          <td> <TimeField value={officeHrsAttrs.config.Friday[0] && officeHrsAttrs.config.Friday[0].end         ?
                                                 officeHrsAttrs.config.Friday[0].end      : '--:--'}
                                          onChange={(e, value) => onTimeChange('OFFICE_HOURS_OF_WEEK','Friday','end',e,value)}      style={{width:'50px'}} /> </td>
                          <td> { officeHrsAttrs.config.Friday[0]    ?
                                   <span onClick={(e) => onTimeClear('OFFICE_HOURS_OF_WEEK','Friday',e)}
                                         style={{ cursor: 'pointer', color: '#646464' }}> <BiXCircle size={18} /> </span> : null} </td>
                        </tr>
                        <tr>
                          <td>{t("I18N_Saturday")}</td>
                          <td> <TimeField value={officeHrsAttrs.config.Saturday[0] && officeHrsAttrs.config.Saturday[0].start   ?
                                                 officeHrsAttrs.config.Saturday[0].start  : '--:--'}
                                          onChange={(e, value) => onTimeChange('OFFICE_HOURS_OF_WEEK','Saturday','start',e,value)}  style={{width:'50px'}} /> </td>
                          <td> <TimeField value={officeHrsAttrs.config.Saturday[0] && officeHrsAttrs.config.Saturday[0].end     ?
                                                 officeHrsAttrs.config.Saturday[0].end    : '--:--'}
                                          onChange={(e, value) => onTimeChange('OFFICE_HOURS_OF_WEEK','Saturday','end',e,value)}    style={{width:'50px'}} /> </td>
                          <td> { officeHrsAttrs.config.Saturday[0]  ?
                                   <span onClick={(e) => onTimeClear('OFFICE_HOURS_OF_WEEK','Saturday',e)}
                                         style={{ cursor: 'pointer', color: '#646464' }}> <BiXCircle size={18} /> </span> : null} </td>
                        </tr>
                        <tr>
                          <td>{t("I18N_Sunday")}</td>
                          <td> <TimeField value={officeHrsAttrs.config.Sunday[0] && officeHrsAttrs.config.Sunday[0].start       ?
                                                 officeHrsAttrs.config.Sunday[0].start    : '--:--'}
                                          onChange={(e, value) => onTimeChange('OFFICE_HOURS_OF_WEEK','Sunday','start',e,value)}    style={{width:'50px'}} /> </td>
                          <td> <TimeField value={officeHrsAttrs.config.Sunday[0] && officeHrsAttrs.config.Sunday[0].end         ?
                                                 officeHrsAttrs.config.Sunday[0].end      : '--:--'}
                                          onChange={(e, value) => onTimeChange('OFFICE_HOURS_OF_WEEK','Sunday','end',e,value)}      style={{width:'50px'}} /> </td>
                          <td> { officeHrsAttrs.config.Sunday[0]    ?
                                   <span onClick={(e) => onTimeClear('OFFICE_HOURS_OF_WEEK','Sunday',e)}
                                         style={{ cursor: 'pointer', color: '#646464' }}> <BiXCircle size={18} /> </span> : null} </td>
                        </tr>
                      </tbody>

                      : officeHrsAttrs.config ?

                      <tbody>
                        <HourSettingRow editMode={false} title={t("I18N_Monday")}    dayVar={officeHrsAttrs.config.Monday[0]}    sect={'OFFICE_HOURS_OF_WEEK'} day={'Monday'}    />
                        <HourSettingRow editMode={false} title={t("I18N_Tuesday")}   dayVar={officeHrsAttrs.config.Tuesday[0]}   sect={'OFFICE_HOURS_OF_WEEK'} day={'Tuesday'}   />
                        <HourSettingRow editMode={false} title={t("I18N_Wednesday")} dayVar={officeHrsAttrs.config.Wednesday[0]} sect={'OFFICE_HOURS_OF_WEEK'} day={'Wednesday'} />
                        <HourSettingRow editMode={false} title={t("I18N_Thursday")}  dayVar={officeHrsAttrs.config.Thursday[0]}  sect={'OFFICE_HOURS_OF_WEEK'} day={'Thursday'}  />
                        <HourSettingRow editMode={false} title={t("I18N_Friday")}    dayVar={officeHrsAttrs.config.Friday[0]}    sect={'OFFICE_HOURS_OF_WEEK'} day={'Friday'}    />
                        <HourSettingRow editMode={false} title={t("I18N_Saturday")}  dayVar={officeHrsAttrs.config.Saturday[0]}  sect={'OFFICE_HOURS_OF_WEEK'} day={'Saturday'}  />
                        <HourSettingRow editMode={false} title={t("I18N_Sunday")}    dayVar={officeHrsAttrs.config.Sunday[0]}    sect={'OFFICE_HOURS_OF_WEEK'} day={'Sunday'}    />
                      </tbody>

                      : null
                    }
                  </Table>
                </Row>

                { !editOfficeHrsMode ?
                  <>
                    <Row className={classes.admin_pages__field_label} style={{ marginTop: '0px', width:'100%' }}>
                      <Col>{t("I18N_Created_by")}:</Col>
                      <Col>{t("I18N_Time_created")}:</Col>
                      <Col>{t("I18N_Updated_by")}:</Col>
                      <Col>{t("I18N_Time_updated")}:</Col>
                    </Row>
                    <Row className={classes.admin_pages__field_value} style={{ marginTop: '0px', width:'100%' }}>
                      <Col style={{overflowWrap:'anywhere'}}>{officeHrsAttrs.creatorUsername}</Col>
                      <Col>{formatDate(officeHrsAttrs.timeCreated)}</Col>
                      <Col style={{overflowWrap:'anywhere'}}>{officeHrsAttrs.updaterUsername}</Col>
                      <Col>{formatDate(officeHrsAttrs.timeUpdated)}</Col>
                    </Row>
                  </>
                : null }

              </div>

              { editOfficeHrsMode ?
                <Row>
                  <div style={{ marginTop: '5px' }}>
                    <Button size="tiny" variant="outline-secondary" className="mb-3"
                      style={{ float: 'left' }}
                      onClick={handleEditOfficeHrsCancel}>
                      {t("I18N_Cancel")}
                    </Button>
                    <Button size="tiny" variant="outline-secondary" className="mb-3"
                      style={{ marginLeft: '15px' }}
                      onClick={handleEditOfficeHrsSubmit}>
                      {t("I18N_Save")}
                    </Button>
                    <span className={classes.admin_pages__field_label} style={{ marginLeft: '30px', color: 'rgba(200,0,0)', verticalAlign: 'top' }}>
                      {editOfficeHrsErr}
                    </span>
                  </div>
                </Row>
                : null
              }
            </>
            : null
          }

          <span className={classes.admin_pages__field_label} style={{ color: 'rgba(200,0,0)' }}>
            {errMsg_fetchOfficeHrs}
          </span>
        </div>

        {/* ----- Business Hours ----- */}

        <div className={classes.admin_pages__page_subtitle} style={{marginTop:'20px'}}>
          <div style={{display:'flex'}}>
            <span>
              {t("I18N_Biz_Hours")}
            </span>
            {editBizHrsMode ?
              null
              : viewBizHrsSect ?
                <span style={{marginLeft:'15px', marginTop: '5px', fontSize:'9px', color:'SteelBlue', cursor:'pointer'}} onClick={handleEditBizHours}>
                  <PencilIcon size={12} />
                  {t("I18N_Edit")}
                </span>
              : null
            }

            <span onClick={(e) => handleToggleViewSect('BUSINESS_HOURS_OF_WEEK',e)}
                  style={{ marginLeft:'auto', marginRight:'20px', marginTop:'2px', cursor: 'pointer', color: '#646464' }}>
              { viewBizHrsSect ? <ChevronUpIcon size={18} /> : <ChevronDownIcon  size={18} /> }
            </span>
          </div>

          <hr className="solid" style={{ margin: '0 0 0 0' }}></hr>

          { viewBizHrsSect && bizHrsAttrs && bizHrsAttrs.config ?
            <>
              <div style={{overflow:'auto', marginLeft:'20px'}}>
                <Row className={classes.admin_pages__field_value} style={{ marginTop: '0px', width:'100%' }}>
                  <Table hover responsive size="sm" style={{marginTop:'10px', width:'500px'}}>
                    <thead style={{color:'#686868', fontSize:'12px', borderBottom:"2px solid #D0D0D0"}}>
                      <tr>
                        <th>{t("I18N_Day_of_week")}</th>
                        <th>{t("I18N_Start") + " (" + t("I18N_24Hour") + ")"}</th>
                        <th>{t("I18N_End")   + " (" + t("I18N_24Hour") + ")"}</th>
                      </tr>
                    </thead>

                    { editBizHrsMode ?

                      <tbody>
{/*
      // ### This portion is not used due to a problem: When the user types 1 number, the control loses focus. ###
      // ### Can use again, if able to find a solution. ###
                        <HourSettingRow editMode={true} title={t("I18N_Monday")}    dayVar={bizHrsAttrs.config.Monday[0]}    sect={'BUSINESS_HOURS_OF_WEEK'} day={'Monday'}
                                        onTimeChange={onTimeChange} onTimeClear={onTimeClear} />
                        <HourSettingRow editMode={true} title={t("I18N_Tuesday")}   dayVar={bizHrsAttrs.config.Tuesday[0]}   sect={'BUSINESS_HOURS_OF_WEEK'} day={'Tuesday'}
                                        onTimeChange={onTimeChange} onTimeClear={onTimeClear} />
                        <HourSettingRow editMode={true} title={t("I18N_Wednesday")} dayVar={bizHrsAttrs.config.Wednesday[0]} sect={'BUSINESS_HOURS_OF_WEEK'} day={'Wednesday'}
                                        onTimeChange={onTimeChange} onTimeClear={onTimeClear} />
                        <HourSettingRow editMode={true} title={t("I18N_Thursday")}  dayVar={bizHrsAttrs.config.Thursday[0]}  sect={'BUSINESS_HOURS_OF_WEEK'} day={'Thursday'}
                                        onTimeChange={onTimeChange} onTimeClear={onTimeClear} />
                        <HourSettingRow editMode={true} title={t("I18N_Friday")}    dayVar={bizHrsAttrs.config.Friday[0]}    sect={'BUSINESS_HOURS_OF_WEEK'} day={'Friday'}
                                        onTimeChange={onTimeChange} onTimeClear={onTimeClear} />
                        <HourSettingRow editMode={true} title={t("I18N_Saturday")}  dayVar={bizHrsAttrs.config.Saturday[0]}  sect={'BUSINESS_HOURS_OF_WEEK'} day={'Saturday'}
                                        onTimeChange={onTimeChange} onTimeClear={onTimeClear} />
                        <HourSettingRow editMode={true} title={t("I18N_Sunday")}    dayVar={bizHrsAttrs.config.Sunday[0]}    sect={'BUSINESS_HOURS_OF_WEEK'} day={'Sunday'}
                                        onTimeChange={onTimeChange} onTimeClear={onTimeClear} />
*/}
                        <tr>
                          <td>{t("I18N_Monday")}</td>
                          <td> <TimeField value={bizHrsAttrs.config.Monday[0] && bizHrsAttrs.config.Monday[0].start      ?
                                                 bizHrsAttrs.config.Monday[0].start    : '--:--'}
                                          onChange={(e, value) => onTimeChange('BUSINESS_HOURS_OF_WEEK','Monday','start',e,value)}    style={{width:'50px'}} /> </td>
                          <td> <TimeField value={bizHrsAttrs.config.Monday[0] && bizHrsAttrs.config.Monday[0].end        ?
                                                 bizHrsAttrs.config.Monday[0].end      : '--:--'}
                                          onChange={(e, value) => onTimeChange('BUSINESS_HOURS_OF_WEEK','Monday','end',e,value)}      style={{width:'50px'}} /> </td>
                          <td> { bizHrsAttrs.config.Monday[0]    ?
                                   <span onClick={(e) => onTimeClear('BUSINESS_HOURS_OF_WEEK','Monday',e)}
                                         style={{ cursor: 'pointer', color: '#646464' }}> <BiXCircle size={18} /> </span> : null} </td>
                        </tr>
                        <tr>
                          <td>{t("I18N_Tuesday")}</td>
                          <td> <TimeField value={bizHrsAttrs.config.Tuesday[0] && bizHrsAttrs.config.Tuesday[0].start    ?
                                                 bizHrsAttrs.config.Tuesday[0].start   : '--:--'}
                                          onChange={(e, value) => onTimeChange('BUSINESS_HOURS_OF_WEEK','Tuesday','start',e,value)}   style={{width:'50px'}} /> </td>
                          <td> <TimeField value={bizHrsAttrs.config.Tuesday[0] && bizHrsAttrs.config.Tuesday[0].end      ?
                                                 bizHrsAttrs.config.Tuesday[0].end     : '--:--'}
                                          onChange={(e, value) => onTimeChange('BUSINESS_HOURS_OF_WEEK','Tuesday','end',e,value)}     style={{width:'50px'}} /> </td>
                          <td> { bizHrsAttrs.config.Tuesday[0]   ?
                                   <span onClick={(e) => onTimeClear('BUSINESS_HOURS_OF_WEEK','Tuesday',e)}
                                         style={{ cursor: 'pointer', color: '#646464' }}> <BiXCircle size={18} /> </span> : null} </td>
                        </tr>
                        <tr>
                          <td>{t("I18N_Wednesday")}</td>
                          <td> <TimeField value={bizHrsAttrs.config.Wednesday[0] && bizHrsAttrs.config.Wednesday[0].start ?
                                                 bizHrsAttrs.config.Wednesday[0].start : '--:--'}
                                          onChange={(e, value) => onTimeChange('BUSINESS_HOURS_OF_WEEK','Wednesday','start',e,value)} style={{width:'50px'}} /> </td>
                          <td> <TimeField value={bizHrsAttrs.config.Wednesday[0] && bizHrsAttrs.config.Wednesday[0].end   ?
                                                 bizHrsAttrs.config.Wednesday[0].end   : '--:--'}
                                          onChange={(e, value) => onTimeChange('BUSINESS_HOURS_OF_WEEK','Wednesday','end',e,value)}   style={{width:'50px'}} /> </td>
                          <td> { bizHrsAttrs.config.Wednesday[0] ?
                                   <span onClick={(e) => onTimeClear('BUSINESS_HOURS_OF_WEEK','Wednesday',e)}
                                         style={{ cursor: 'pointer', color: '#646464' }}> <BiXCircle size={18} /> </span> : null} </td>
                        </tr>
                        <tr>
                          <td>{t("I18N_Thursday")}</td>
                          <td> <TimeField value={bizHrsAttrs.config.Thursday[0] && bizHrsAttrs.config.Thursday[0].start   ?
                                                 bizHrsAttrs.config.Thursday[0].start  : '--:--'}
                                          onChange={(e, value) => onTimeChange('BUSINESS_HOURS_OF_WEEK','Thursday','start',e,value)}  style={{width:'50px'}} /> </td>
                          <td> <TimeField value={bizHrsAttrs.config.Thursday[0] && bizHrsAttrs.config.Thursday[0].end     ?
                                                 bizHrsAttrs.config.Thursday[0].end    : '--:--'}
                                          onChange={(e, value) => onTimeChange('BUSINESS_HOURS_OF_WEEK','Thursday','end',e,value)}    style={{width:'50px'}} /> </td>
                          <td> { bizHrsAttrs.config.Thursday[0]  ?
                                   <span onClick={(e) => onTimeClear('BUSINESS_HOURS_OF_WEEK','Thursday',e)}
                                         style={{ cursor: 'pointer', color: '#646464' }}> <BiXCircle size={18} /> </span> : null} </td>
                        </tr>
                        <tr>
                          <td>{t("I18N_Friday")}</td>
                          <td> <TimeField value={bizHrsAttrs.config.Friday[0] && bizHrsAttrs.config.Friday[0].start       ?
                                                 bizHrsAttrs.config.Friday[0].start    : '--:--'}
                                          onChange={(e, value) => onTimeChange('BUSINESS_HOURS_OF_WEEK','Friday','start',e,value)}    style={{width:'50px'}} /> </td>
                          <td> <TimeField value={bizHrsAttrs.config.Friday[0] && bizHrsAttrs.config.Friday[0].end         ?
                                                 bizHrsAttrs.config.Friday[0].end      : '--:--'}
                                          onChange={(e, value) => onTimeChange('BUSINESS_HOURS_OF_WEEK','Friday','end',e,value)}      style={{width:'50px'}} /> </td>
                          <td> { bizHrsAttrs.config.Friday[0]    ?
                                   <span onClick={(e) => onTimeClear('BUSINESS_HOURS_OF_WEEK','Friday',e)}
                                         style={{ cursor: 'pointer', color: '#646464' }}> <BiXCircle size={18} /> </span> : null} </td>
                        </tr>
                        <tr>
                          <td>{t("I18N_Saturday")}</td>
                          <td> <TimeField value={bizHrsAttrs.config.Saturday[0] && bizHrsAttrs.config.Saturday[0].start   ?
                                                 bizHrsAttrs.config.Saturday[0].start  : '--:--'}
                                          onChange={(e, value) => onTimeChange('BUSINESS_HOURS_OF_WEEK','Saturday','start',e,value)}  style={{width:'50px'}} /> </td>
                          <td> <TimeField value={bizHrsAttrs.config.Saturday[0] && bizHrsAttrs.config.Saturday[0].end     ?
                                                 bizHrsAttrs.config.Saturday[0].end    : '--:--'}
                                          onChange={(e, value) => onTimeChange('BUSINESS_HOURS_OF_WEEK','Saturday','end',e,value)}    style={{width:'50px'}} /> </td>
                          <td> { bizHrsAttrs.config.Saturday[0]  ?
                                   <span onClick={(e) => onTimeClear('BUSINESS_HOURS_OF_WEEK','Saturday',e)}
                                         style={{ cursor: 'pointer', color: '#646464' }}> <BiXCircle size={18} /> </span> : null} </td>
                        </tr>
                        <tr>
                          <td>{t("I18N_Sunday")}</td>
                          <td> <TimeField value={bizHrsAttrs.config.Sunday[0] && bizHrsAttrs.config.Sunday[0].start       ?
                                                 bizHrsAttrs.config.Sunday[0].start    : '--:--'}
                                          onChange={(e, value) => onTimeChange('BUSINESS_HOURS_OF_WEEK','Sunday','start',e,value)}    style={{width:'50px'}} /> </td>
                          <td> <TimeField value={bizHrsAttrs.config.Sunday[0] && bizHrsAttrs.config.Sunday[0].end         ?
                                                 bizHrsAttrs.config.Sunday[0].end      : '--:--'}
                                          onChange={(e, value) => onTimeChange('BUSINESS_HOURS_OF_WEEK','Sunday','end',e,value)}      style={{width:'50px'}} /> </td>
                          <td> { bizHrsAttrs.config.Sunday[0]    ?
                                   <span onClick={(e) => onTimeClear('BUSINESS_HOURS_OF_WEEK','Sunday',e)}
                                         style={{ cursor: 'pointer', color: '#646464' }}> <BiXCircle size={18} /> </span> : null} </td>
                        </tr>
                      </tbody>

                      : bizHrsAttrs.config ?

                      <tbody>
                        <HourSettingRow editMode={false} title={t("I18N_Monday")}    dayVar={bizHrsAttrs.config.Monday[0]}    sect={'BUSINESS_HOURS_OF_WEEK'} day={'Monday'}    />
                        <HourSettingRow editMode={false} title={t("I18N_Tuesday")}   dayVar={bizHrsAttrs.config.Tuesday[0]}   sect={'BUSINESS_HOURS_OF_WEEK'} day={'Tuesday'}   />
                        <HourSettingRow editMode={false} title={t("I18N_Wednesday")} dayVar={bizHrsAttrs.config.Wednesday[0]} sect={'BUSINESS_HOURS_OF_WEEK'} day={'Wednesday'} />
                        <HourSettingRow editMode={false} title={t("I18N_Thursday")}  dayVar={bizHrsAttrs.config.Thursday[0]}  sect={'BUSINESS_HOURS_OF_WEEK'} day={'Thursday'}  />
                        <HourSettingRow editMode={false} title={t("I18N_Friday")}    dayVar={bizHrsAttrs.config.Friday[0]}    sect={'BUSINESS_HOURS_OF_WEEK'} day={'Friday'}    />
                        <HourSettingRow editMode={false} title={t("I18N_Saturday")}  dayVar={bizHrsAttrs.config.Saturday[0]}  sect={'BUSINESS_HOURS_OF_WEEK'} day={'Saturday'}  />
                        <HourSettingRow editMode={false} title={t("I18N_Sunday")}    dayVar={bizHrsAttrs.config.Sunday[0]}    sect={'BUSINESS_HOURS_OF_WEEK'} day={'Sunday'}    />
                      </tbody>

                      : null
                    }
                  </Table>
                </Row>

                { !editBizHrsMode ?
                  <>
                    <Row className={classes.admin_pages__field_label} style={{ marginTop: '0px', width:'100%' }}>
                      <Col>{t("I18N_Created_by")}:</Col>
                      <Col>{t("I18N_Time_created")}:</Col>
                      <Col>{t("I18N_Updated_by")}:</Col>
                      <Col>{t("I18N_Time_updated")}:</Col>
                    </Row>
                    <Row className={classes.admin_pages__field_value} style={{ marginTop: '0px', width:'100%' }}>
                      <Col style={{overflowWrap:'anywhere'}}>{bizHrsAttrs.creatorUsername}</Col>
                      <Col>{formatDate(bizHrsAttrs.timeCreated)}</Col>
                      <Col style={{overflowWrap:'anywhere'}}>{bizHrsAttrs.updaterUsername}</Col>
                      <Col>{formatDate(bizHrsAttrs.timeUpdated)}</Col>
                    </Row>
                  </>
                : null }

              </div>

              { editBizHrsMode ?
                <Row>
                  <div style={{ marginTop: '5px' }}>
                    <Button size="tiny" variant="outline-secondary" className="mb-3"
                      style={{ float: 'left' }}
                      onClick={handleEditBizHrsCancel}>
                      {t("I18N_Cancel")}
                    </Button>
                    <Button size="tiny" variant="outline-secondary" className="mb-3"
                      style={{ marginLeft: '15px' }}
                      onClick={handleEditBizHrsSubmit}>
                      {t("I18N_Save")}
                    </Button>
                    <span className={classes.admin_pages__field_label} style={{ marginLeft: '30px', color: 'rgba(200,0,0)', verticalAlign: 'top' }}>
                      {editBizHrsErr}
                    </span>
                  </div>
                </Row>
                : null
              }
            </>
            : null
          }

          <span className={classes.admin_pages__field_label} style={{ color: 'rgba(200,0,0)' }}>
            {errMsg_fetchBizHrs}
          </span>
        </div>


        {/* ----- FM Hours ----- */}

        <div className={classes.admin_pages__page_subtitle} style={{marginTop:'20px'}}>
          <div style={{display:'flex'}}>
            <span>
              {t("I18N_FM_Hours")}
            </span>
            {editFmHrsMode ?
              null
              : viewFmHrsSect ?
                <span style={{marginLeft:'15px', marginTop: '5px', fontSize:'9px', color:'SteelBlue', cursor:'pointer'}} onClick={handleEditFmHours}>
                  <PencilIcon size={12} />
                  {t("I18N_Edit")}
                </span>
              : null
            }

            <span onClick={(e) => handleToggleViewSect('FM_DAY_SHIFT_HOURS_OF_WEEK',e)}
                  style={{ marginLeft:'auto', marginRight:'20px', marginTop:'2px', cursor: 'pointer', color: '#646464' }}>
              { viewFmHrsSect ? <ChevronUpIcon size={18} /> : <ChevronDownIcon  size={18} /> }
            </span>
          </div>

          <hr className="solid" style={{ margin: '0 0 0 0' }}></hr>

          { viewFmHrsSect && fmHrsAttrs && fmHrsAttrs.config ?
            <>
              <div style={{overflow:'auto', marginLeft:'20px'}}>
                <Row className={classes.admin_pages__field_value} style={{ marginTop: '0px', width:'100%' }}>
                  <Table hover responsive size="sm" style={{marginTop:'10px', width:'500px'}}>
                    <thead style={{color:'#686868', fontSize:'12px', borderBottom:"2px solid #D0D0D0"}}>
                      <tr>
                        <th>{t("I18N_Day_of_week")}</th>
                        <th>{t("I18N_Start") + " (" + t("I18N_24Hour") + ")"}</th>
                        <th>{t("I18N_End")   + " (" + t("I18N_24Hour") + ")"}</th>
                      </tr>
                    </thead>

                    { editFmHrsMode ?

                      <tbody>
{/*
      // ### This portion is not used due to a problem: When the user types 1 number, the control loses focus. ###
      // ### Can use again, if able to find a solution. ###
                        <HourSettingRow editMode={true} title={t("I18N_Monday")}    dayVar={fmHrsAttrs.config.Monday[0]}    sect={'FM_DAY_SHIFT_HOURS_OF_WEEK'} day={'Monday'}
                                        onTimeChange={onTimeChange} onTimeClear={onTimeClear} />
                        <HourSettingRow editMode={true} title={t("I18N_Tuesday")}   dayVar={fmHrsAttrs.config.Tuesday[0]}   sect={'FM_DAY_SHIFT_HOURS_OF_WEEK'} day={'Tuesday'}
                                        onTimeChange={onTimeChange} onTimeClear={onTimeClear} />
                        <HourSettingRow editMode={true} title={t("I18N_Wednesday")} dayVar={fmHrsAttrs.config.Wednesday[0]} sect={'FM_DAY_SHIFT_HOURS_OF_WEEK'} day={'Wednesday'}
                                        onTimeChange={onTimeChange} onTimeClear={onTimeClear} />
                        <HourSettingRow editMode={true} title={t("I18N_Thursday")}  dayVar={fmHrsAttrs.config.Thursday[0]}  sect={'FM_DAY_SHIFT_HOURS_OF_WEEK'} day={'Thursday'}
                                        onTimeChange={onTimeChange} onTimeClear={onTimeClear} />
                        <HourSettingRow editMode={true} title={t("I18N_Friday")}    dayVar={fmHrsAttrs.config.Friday[0]}    sect={'FM_DAY_SHIFT_HOURS_OF_WEEK'} day={'Friday'}
                                        onTimeChange={onTimeChange} onTimeClear={onTimeClear} />
                        <HourSettingRow editMode={true} title={t("I18N_Saturday")}  dayVar={fmHrsAttrs.config.Saturday[0]}  sect={'FM_DAY_SHIFT_HOURS_OF_WEEK'} day={'Saturday'}
                                        onTimeChange={onTimeChange} onTimeClear={onTimeClear} />
                        <HourSettingRow editMode={true} title={t("I18N_Sunday")}    dayVar={fmHrsAttrs.config.Sunday[0]}    sect={'FM_DAY_SHIFT_HOURS_OF_WEEK'} day={'Sunday'}
                                        onTimeChange={onTimeChange} onTimeClear={onTimeClear} />
*/}
                        <tr>
                          <td>{t("I18N_Monday")}</td>
                          <td> <TimeField value={fmHrsAttrs.config.Monday[0] && fmHrsAttrs.config.Monday[0].start      ?
                                                 fmHrsAttrs.config.Monday[0].start    : '--:--'}
                                          onChange={(e, value) => onTimeChange('FM_DAY_SHIFT_HOURS_OF_WEEK','Monday','start',e,value)}    style={{width:'50px'}} /> </td>
                          <td> <TimeField value={fmHrsAttrs.config.Monday[0] && fmHrsAttrs.config.Monday[0].end        ?
                                                 fmHrsAttrs.config.Monday[0].end      : '--:--'}
                                          onChange={(e, value) => onTimeChange('FM_DAY_SHIFT_HOURS_OF_WEEK','Monday','end',e,value)}      style={{width:'50px'}} /> </td>
                          <td> { fmHrsAttrs.config.Monday[0]    ?
                                   <span onClick={(e) => onTimeClear('FM_DAY_SHIFT_HOURS_OF_WEEK','Monday',e)}
                                         style={{ cursor: 'pointer', color: '#646464' }}> <BiXCircle size={18} /> </span> : null} </td>
                        </tr>
                        <tr>
                          <td>{t("I18N_Tuesday")}</td>
                          <td> <TimeField value={fmHrsAttrs.config.Tuesday[0] && fmHrsAttrs.config.Tuesday[0].start    ?
                                                 fmHrsAttrs.config.Tuesday[0].start   : '--:--'}
                                          onChange={(e, value) => onTimeChange('FM_DAY_SHIFT_HOURS_OF_WEEK','Tuesday','start',e,value)}   style={{width:'50px'}} /> </td>
                          <td> <TimeField value={fmHrsAttrs.config.Tuesday[0] && fmHrsAttrs.config.Tuesday[0].end      ?
                                                 fmHrsAttrs.config.Tuesday[0].end     : '--:--'}
                                          onChange={(e, value) => onTimeChange('FM_DAY_SHIFT_HOURS_OF_WEEK','Tuesday','end',e,value)}     style={{width:'50px'}} /> </td>
                          <td> { fmHrsAttrs.config.Tuesday[0]   ?
                                   <span onClick={(e) => onTimeClear('FM_DAY_SHIFT_HOURS_OF_WEEK','Tuesday',e)}
                                         style={{ cursor: 'pointer', color: '#646464' }}> <BiXCircle size={18} /> </span> : null} </td>
                        </tr>
                        <tr>
                          <td>{t("I18N_Wednesday")}</td>
                          <td> <TimeField value={fmHrsAttrs.config.Wednesday[0] && fmHrsAttrs.config.Wednesday[0].start ?
                                                 fmHrsAttrs.config.Wednesday[0].start : '--:--'}
                                          onChange={(e, value) => onTimeChange('FM_DAY_SHIFT_HOURS_OF_WEEK','Wednesday','start',e,value)} style={{width:'50px'}} /> </td>
                          <td> <TimeField value={fmHrsAttrs.config.Wednesday[0] && fmHrsAttrs.config.Wednesday[0].end   ?
                                                 fmHrsAttrs.config.Wednesday[0].end   : '--:--'}
                                          onChange={(e, value) => onTimeChange('FM_DAY_SHIFT_HOURS_OF_WEEK','Wednesday','end',e,value)}   style={{width:'50px'}} /> </td>
                          <td> { fmHrsAttrs.config.Wednesday[0] ?
                                   <span onClick={(e) => onTimeClear('FM_DAY_SHIFT_HOURS_OF_WEEK','Wednesday',e)}
                                         style={{ cursor: 'pointer', color: '#646464' }}> <BiXCircle size={18} /> </span> : null} </td>
                        </tr>
                        <tr>
                          <td>{t("I18N_Thursday")}</td>
                          <td> <TimeField value={fmHrsAttrs.config.Thursday[0] && fmHrsAttrs.config.Thursday[0].start   ?
                                                 fmHrsAttrs.config.Thursday[0].start  : '--:--'}
                                          onChange={(e, value) => onTimeChange('FM_DAY_SHIFT_HOURS_OF_WEEK','Thursday','start',e,value)}  style={{width:'50px'}} /> </td>
                          <td> <TimeField value={fmHrsAttrs.config.Thursday[0] && fmHrsAttrs.config.Thursday[0].end     ?
                                                 fmHrsAttrs.config.Thursday[0].end    : '--:--'}
                                          onChange={(e, value) => onTimeChange('FM_DAY_SHIFT_HOURS_OF_WEEK','Thursday','end',e,value)}    style={{width:'50px'}} /> </td>
                          <td> { fmHrsAttrs.config.Thursday[0]  ?
                                   <span onClick={(e) => onTimeClear('FM_DAY_SHIFT_HOURS_OF_WEEK','Thursday',e)}
                                         style={{ cursor: 'pointer', color: '#646464' }}> <BiXCircle size={18} /> </span> : null} </td>
                        </tr>
                        <tr>
                          <td>{t("I18N_Friday")}</td>
                          <td> <TimeField value={fmHrsAttrs.config.Friday[0] && fmHrsAttrs.config.Friday[0].start       ?
                                                 fmHrsAttrs.config.Friday[0].start    : '--:--'}
                                          onChange={(e, value) => onTimeChange('FM_DAY_SHIFT_HOURS_OF_WEEK','Friday','start',e,value)}    style={{width:'50px'}} /> </td>
                          <td> <TimeField value={fmHrsAttrs.config.Friday[0] && fmHrsAttrs.config.Friday[0].end         ?
                                                 fmHrsAttrs.config.Friday[0].end      : '--:--'}
                                          onChange={(e, value) => onTimeChange('FM_DAY_SHIFT_HOURS_OF_WEEK','Friday','end',e,value)}      style={{width:'50px'}} /> </td>
                          <td> { fmHrsAttrs.config.Friday[0]    ?
                                   <span onClick={(e) => onTimeClear('FM_DAY_SHIFT_HOURS_OF_WEEK','Friday',e)}
                                         style={{ cursor: 'pointer', color: '#646464' }}> <BiXCircle size={18} /> </span> : null} </td>
                        </tr>
                        <tr>
                          <td>{t("I18N_Saturday")}</td>
                          <td> <TimeField value={fmHrsAttrs.config.Saturday[0] && fmHrsAttrs.config.Saturday[0].start   ?
                                                 fmHrsAttrs.config.Saturday[0].start  : '--:--'}
                                          onChange={(e, value) => onTimeChange('FM_DAY_SHIFT_HOURS_OF_WEEK','Saturday','start',e,value)}  style={{width:'50px'}} /> </td>
                          <td> <TimeField value={fmHrsAttrs.config.Saturday[0] && fmHrsAttrs.config.Saturday[0].end     ?
                                                 fmHrsAttrs.config.Saturday[0].end    : '--:--'}
                                          onChange={(e, value) => onTimeChange('FM_DAY_SHIFT_HOURS_OF_WEEK','Saturday','end',e,value)}    style={{width:'50px'}} /> </td>
                          <td> { fmHrsAttrs.config.Saturday[0]  ?
                                   <span onClick={(e) => onTimeClear('FM_DAY_SHIFT_HOURS_OF_WEEK','Saturday',e)}
                                         style={{ cursor: 'pointer', color: '#646464' }}> <BiXCircle size={18} /> </span> : null} </td>
                        </tr>
                        <tr>
                          <td>{t("I18N_Sunday")}</td>
                          <td> <TimeField value={fmHrsAttrs.config.Sunday[0] && fmHrsAttrs.config.Sunday[0].start       ?
                                                 fmHrsAttrs.config.Sunday[0].start    : '--:--'}
                                          onChange={(e, value) => onTimeChange('FM_DAY_SHIFT_HOURS_OF_WEEK','Sunday','start',e,value)}    style={{width:'50px'}} /> </td>
                          <td> <TimeField value={fmHrsAttrs.config.Sunday[0] && fmHrsAttrs.config.Sunday[0].end         ?
                                                 fmHrsAttrs.config.Sunday[0].end      : '--:--'}
                                          onChange={(e, value) => onTimeChange('FM_DAY_SHIFT_HOURS_OF_WEEK','Sunday','end',e,value)}      style={{width:'50px'}} /> </td>
                          <td> { fmHrsAttrs.config.Sunday[0]    ?
                                   <span onClick={(e) => onTimeClear('FM_DAY_SHIFT_HOURS_OF_WEEK','Sunday',e)}
                                         style={{ cursor: 'pointer', color: '#646464' }}> <BiXCircle size={18} /> </span> : null} </td>
                        </tr>
                      </tbody>

                      : fmHrsAttrs.config ?

                      <tbody>
                        <HourSettingRow editMode={false} title={t("I18N_Monday")}    dayVar={fmHrsAttrs.config.Monday[0]}    sect={'FM_DAY_SHIFT_HOURS_OF_WEEK'} day={'Monday'}    />
                        <HourSettingRow editMode={false} title={t("I18N_Tuesday")}   dayVar={fmHrsAttrs.config.Tuesday[0]}   sect={'FM_DAY_SHIFT_HOURS_OF_WEEK'} day={'Tuesday'}   />
                        <HourSettingRow editMode={false} title={t("I18N_Wednesday")} dayVar={fmHrsAttrs.config.Wednesday[0]} sect={'FM_DAY_SHIFT_HOURS_OF_WEEK'} day={'Wednesday'} />
                        <HourSettingRow editMode={false} title={t("I18N_Thursday")}  dayVar={fmHrsAttrs.config.Thursday[0]}  sect={'FM_DAY_SHIFT_HOURS_OF_WEEK'} day={'Thursday'}  />
                        <HourSettingRow editMode={false} title={t("I18N_Friday")}    dayVar={fmHrsAttrs.config.Friday[0]}    sect={'FM_DAY_SHIFT_HOURS_OF_WEEK'} day={'Friday'}    />
                        <HourSettingRow editMode={false} title={t("I18N_Saturday")}  dayVar={fmHrsAttrs.config.Saturday[0]}  sect={'FM_DAY_SHIFT_HOURS_OF_WEEK'} day={'Saturday'}  />
                        <HourSettingRow editMode={false} title={t("I18N_Sunday")}    dayVar={fmHrsAttrs.config.Sunday[0]}    sect={'FM_DAY_SHIFT_HOURS_OF_WEEK'} day={'Sunday'}    />
                      </tbody>

                      : null
                    }
                  </Table>
                </Row>

                { !editFmHrsMode ?
                  <>
                    <Row className={classes.admin_pages__field_label} style={{ marginTop: '0px', width:'100%' }}>
                      <Col>{t("I18N_Created_by")}:</Col>
                      <Col>{t("I18N_Time_created")}:</Col>
                      <Col>{t("I18N_Updated_by")}:</Col>
                      <Col>{t("I18N_Time_updated")}:</Col>
                    </Row>
                    <Row className={classes.admin_pages__field_value} style={{ marginTop: '0px', width:'100%' }}>
                      <Col style={{overflowWrap:'anywhere'}}>{fmHrsAttrs.creatorUsername}</Col>
                      <Col>{formatDate(fmHrsAttrs.timeCreated)}</Col>
                      <Col style={{overflowWrap:'anywhere'}}>{fmHrsAttrs.updaterUsername}</Col>
                      <Col>{formatDate(fmHrsAttrs.timeUpdated)}</Col>
                    </Row>
                  </>
                : null }

              </div>

              { editFmHrsMode ?
                <Row>
                  <div style={{ marginTop: '5px' }}>
                    <Button size="tiny" variant="outline-secondary" className="mb-3"
                      style={{ float: 'left' }}
                      onClick={handleEditFmHrsCancel}>
                      {t("I18N_Cancel")}
                    </Button>
                    <Button size="tiny" variant="outline-secondary" className="mb-3"
                      style={{ marginLeft: '15px' }}
                      onClick={handleEditFmHrsSubmit}>
                      {t("I18N_Save")}
                    </Button>
                    <span className={classes.admin_pages__field_label} style={{ marginLeft: '30px', color: 'rgba(200,0,0)', verticalAlign: 'top' }}>
                      {editFmHrsErr}
                    </span>
                  </div>
                </Row>
                : null
              }
            </>
            : null
          }

          <span className={classes.admin_pages__field_label} style={{ color: 'rgba(200,0,0)' }}>
            {errMsg_fetchFmHrs}
          </span>
        </div>

        <Modal show={pubHolidayDialogMode !== 'CLOSE'} onHide={handlePubHolidayDialogClose} centered >
          <Modal.Body>
            <div>
              <span>
                { (pubHolidayDialogMode === 'NEW')  ? t("I18N_New_pub_holiday") :
                  (pubHolidayDialogMode === 'EDIT') ? t("I18N_Edit_pub_holiday") : null }
              </span>

              <hr className="solid" style={{ margin: '0 0 10px 0' }}></hr>

              <Row className={classes.admin_pages__field_label}>
                <Col>{t("I18N_Date")}: *</Col>
              </Row>
              <Row className={classes.admin_pages__field_value}>
                <Col>
                  <DateTimePicker onChange={onDatepickerChange} value={targetPubHoliday ? targetPubHoliday.date : null}
                     format={ "y-MM-dd" }
                     // minDate={new Date(3600000 * ( Math.round(Date.now() / 3600000)))}
                     disableClock="true"
                     clearIcon=<BiXCircle size={16} style={{color:"gray"}}/>
                     calendarIcon=<BiCalendar size={16} style={{color:"gray"}}/>
                     locale={i18n.language === 'zh_HK' ? "zh-HK" : (i18n.language === 'zh_CN' ? "zh-CN" : "en")}
                  />
                </Col>
              </Row>

              <Row className={classes.admin_pages__field_label} style={{marginTop:'10px'}} >
                <Col>{t("I18N_Name")}: *</Col>
              </Row>
              <Row className={classes.admin_pages__field_value}>
                <Col>
                  <input className={classes.admin_pages__field_editable} style={{width:'100%'}} name="name_en"
                         value={targetPubHoliday ? targetPubHoliday.name_en : ''}
                         onChange={(e) => onInputChange(e)} />
                </Col>
              </Row>

              <Row className={classes.admin_pages__field_label} style={{marginTop:'10px'}} >
                <Col>{t("I18N_Name") + " (" + t("custom:I18N_Language_2") + ")"}: *</Col>
              </Row>
              <Row className={classes.admin_pages__field_value}>
                <Col>
                <input className={classes.admin_pages__field_editable} style={{width:'100%'}} name="name_zh_HK"
                       value={targetPubHoliday ? targetPubHoliday.name_zh_HK : ''}
                       onChange={(e) => onInputChange(e)} />
                </Col>
              </Row>

              <Row className={classes.admin_pages__field_label} style={{marginTop:'10px'}} >
                <Col>{t("I18N_Name") + " (" + t("custom:I18N_Language_3") + ")"}: *</Col>
              </Row>
              <Row className={classes.admin_pages__field_value}>
                <Col>
                <input className={classes.admin_pages__field_editable} style={{width:'100%'}} name="name_zh_CN"
                       value={targetPubHoliday ? targetPubHoliday.name_zh_CN : ''}
                       onChange={(e) => onInputChange(e)} />
                </Col>
              </Row>

              {/*
              <Row className={classes.admin_pages__field_label} style={{marginTop:'10px'}} >
                <Col>{t("I18N_Description")}: *</Col>
              </Row>
              <Row className={classes.admin_pages__field_value}>
                <Col>
                  <textarea className={classes.admin_pages__field_editable} style={{width:'100%'}} name="description"
                            value={targetPubHoliday ? targetPubHoliday.description : ''}
                            onChange={(e) => onInputChange(e)} />
                </Col>
              </Row>
              */}

              <Row className={classes.admin_pages__field_label} style={{marginTop:'10px', fontStyle:'italic'}}>
                <span>{t("I18N_Req_fields")}</span>
              </Row>
              <Row>
                <span className={classes.admin_pages__field_label} style={{marginTop:'5px', color:'rgba(200,0,0)', verticalAlign:'top'}}>
                  {errMsg_pubHolidayDialog}
                </span>
              </Row>

              <Row>
                <div display='flex' style={{marginTop:'15px'}}>
                  <Button size="tiny" variant="outline-secondary" className="mb-3"
                    style={{ float: 'left' }}
                    onClick={handlePubHolidayDialogClose}>
                    {t("I18N_Cancel")}
                  </Button>
                  <Button size="tiny" variant="outline-secondary" className="mb-3"
                    style={{ marginLeft: '15px' }}
                    onClick={pubHolidayDialogMode === 'NEW' ? handleAddPubHolidaySubmit : handleEditPubHolidaySubmit }>
                    {t("I18N_Save")}
                  </Button>
                </div>
              </Row>
            </div>
          </Modal.Body>
        </Modal>

        <DeleteConfirmDialog
          title={t("I18N_Holiday_remove_confirm")}
          show={showDeleteDialog}
          targetName={deleteTarget ? deleteTarget.name.en + ' / ' + deleteTarget.name.zh_HK + ' / ' + deleteTarget.name.zh_CN: ''}
          errMsgDeleteConfirm={errMsgDeleteConfirm}
          onCancel={handleDeleteCancel}
          onSubmit={handleDeleteSubmit}
        />

      </Card>
    </>
  );
}

export default CalConfigAdminDetailsView;
